import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useLanguage } from '../../locale/useLanguage';
import { Button } from '../Button/Button';
import { Modal, ModalRef } from '../Modal/Modal';

import './ConfirmationModal.css';

type ConfirmationModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  title: React.ReactNode;
  description: React.ReactNode;
  confirmButtonText?: string;
};

export const ConfirmationModal: React.ForwardRefExoticComponent<
  ConfirmationModalProps & React.RefAttributes<ModalRef>
> = forwardRef(
  (
    { onConfirm, onCancel, title, description, confirmButtonText },
    forwardedRef
  ) => {
    const [t] = useLanguage();
    const modalRef = useRef<ModalRef>(null);

    useImperativeHandle(forwardedRef, () => ({
      openModal: modalRef.current!.openModal,
      closeModal: modalRef.current!.closeModal,
    }));

    return (
      <>
        <Modal ref={modalRef} onClose={onCancel}>
          <h3 className="modal-title">{title}</h3>
          <p className="modal-description">{description}</p>
          <div className="modal-button-container">
            <Button
              onClick={onConfirm}
              label={confirmButtonText || t('addressNotesView.confirm')}
              isPrimary
            />
          </div>
        </Modal>
      </>
    );
  }
);
